export default [
  {
    path: '/funding',
    component: () => import('@/components/layouts/funding-layout.vue'),
    meta: { title: 'Funding', authenticated: true, activeUser: false },
    children: [
      {
        path: '',
        redirect: { name: 'funding#incoming-ach' },
      },
      {
        path: 'incoming',
        component: () => import('@/components/layouts/funding/incoming-layout.vue'),
        meta: { title: 'Incoming Funds' },
        children: [
          {
            path: '',
            name: 'funding#incoming-overview',
            meta: { title: 'Fund your Account' },
            component: () => import('@/views/funding/incoming/overview-view.vue'),
          },
          {
            name: 'funding#incoming-ach',
            path: 'ach',
            meta: { title: 'ACH' },
            component: () => import('@/views/funding/incoming/ach-view.vue'),
          },
          {
            name: 'funding#incoming-wire',
            path: 'wire',
            meta: { title: 'Wire' },
            component: () => import('@/views/funding/incoming/wire-view.vue'),
          },
          {
            name: 'funding#incoming-check',
            path: 'check',
            meta: { title: 'Check' },
            component: () => import('@/views/funding/incoming/check-view.vue'),
          },
        ],
      },
      {
        path: 'outgoing',
        component: () => import('@/components/layouts/funding/outgoing-layout.vue'),
        meta: { title: 'Outgoing Funds' },
        children: [
          {
            path: '',
            name: 'funding#outgoing-overview',
            meta: { title: 'Withdraw Funds' },
            component: () => import('@/views/funding/outgoing/overview-view.vue'),
          },
          {
            name: 'funding#outgoing-ach',
            path: 'ach',
            meta: { title: 'ACH' },
            component: () => import('@/views/funding/outgoing/ach-view.vue'),
          },
          {
            name: 'funding#outgoing-wire',
            path: 'wire',
            meta: { title: 'Wire' },
            component: () => import('@/views/funding/outgoing/wire-view.vue'),
          },
          {
            name: 'funding#outgoing-check',
            path: 'check',
            meta: { title: 'Check' },
            component: () => import('@/views/funding/outgoing/check-view.vue'),
          },
        ],
      },
      {
        path: 'transfers',
        component: () => import('@/components/layouts/funding/transfer-layout.vue'),
        meta: { title: 'Transfers' },
        children: [
          {
            path: '',
            name: 'funding#transfers-overview',
            meta: { title: 'Transfers' },
            component: () => import('@/views/funding/transfers/overview-view.vue'),
          },
          {
            name: 'funding#transfers-external',
            path: 'external',
            meta: { title: 'External Transfers' },
            component: () => import('@/views/funding/transfers/external-view.vue'),
          },
          {
            name: 'funding#transfers-internal',
            path: 'internal',
            meta: { title: 'Internal Transfers' },
            component: () => import('@/views/funding/transfers/internal-view.vue'),
          },
        ],
      },
    ],
  },
];
